<template>
    <div class="container_layout">
       <el-row class="guide_title">
            <el-col :span="16" :offset="4">請選擇受眾鎖定方式？</el-col>
        </el-row>
       <el-row :gutter="24" style="text-align: 'center'">
          <RadioGroup
              :optionType="2"
              :delay="200"
              :items="items"
              :activatedId="activatedId"
              :showInfo="{}"
              :suggestions="suggestions"
              :spanProp="6"
              @change="onUpdateSelectedItem">
          </RadioGroup>
          <!--showInfo 沒有隨便給個空物件會報錯, 原因不明-->
        </el-row>
    </div>
</template>

<script>
import HpcSuggestion from '@/views/HpcSuggestion'
import RadioGroup from '../components/RadioGroup'
import { GUIDE_ACTIONS, GUIDE_MUTATIONS } from '../../../store/modules/guide'
import { PATH_TYPE } from '../Const'

export default {
  name: 'step2',
  components: {
    HpcSuggestion,
    RadioGroup
  },
  props: ['path'],
  data () {
    return {
      // @FIXME:
      // suggestions 目前內容無用，只能表示需要 suggestion。內容目前寫死在 RadioGroup
      // 用這個套件可解問題，但預到一些 bug 先沒用。v-runtime-template https://github.com/alexjoverm/v-runtime-template
      // 有機會再試
      suggestions: [
        '<p>年齡性別：18-55+歲、男性/女性/全部</p>',
        '<p>分析特定產業的<HpcSuggestion></HpcSuggestion>之輪廓樣貌，並鎖定相似輪廓的受眾</p>',
        '<p>依據消費者的網海行為貼標(閱覽興趣、造訪網站類型...etc)，當某一類型之標籤達到一定濃度時，則將之分群至所屬族群</p>'
      ]
    }
  },
  computed: {
    isAudiencePath () {
      return this.path === PATH_TYPE.AUDIENCE
    },
    activatedId () {
      return this.$store.state.guide[this.path].targetType.id
    },
    items () {
      return this.$store.state.guide.root.optionData.targetCategory
    }
  },
  methods: {
    onUpdateSelectedItem (data) {
      if (this.isAudiencePath) {
        this.$store.commit(GUIDE_MUTATIONS.AUDIENCE.SET_TARGET_TYPE, data)
        this.$store.dispatch(GUIDE_ACTIONS.AUDIENCE.RESET_OPTION)
      } else {
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.SET_TARGET_TYPE, data)
        this.$store.commit(GUIDE_MUTATIONS.PURPOSE.RESET_TARGET_OPTION, data)
      }
    }
  }
}
</script>
